
export const appVersion = {
	name: 'coachway',
    timestamp: 'Sun, 08 Jun 2025 11:31:16 GMT',
    versionHash: '1749382276862',
    version: '2.1.0'
};
